export default "__VITE_ASSET__BAd8rPNR__"